<ins-form-field
	type="outlined"
	[tooltip]="showSelectedAllText() || showSelectedCountText() ? tooltipValues() : []"
	class="label-inline form-field--frame"
	[label]="chip().label + ':'"
>
	<ins-select
		multiple="true"
		display-text="displayLabel"
		[converter]="converter"
		[ngModel]="visibleValue()"
		(ngModelChange)="onValueChange($event)"
		[placeholder]="'ui.placeholders.empty' | translate"
	>
		@if (showSelectedAllText()) {
			<span slot="content">
				{{ 'ui.filter-chips.selected-all' | translate }}
			</span>
		}

		@if (showSelectedCountText()) {
			<span slot="content">
				{{ 'ui.filter-chips.selected-count' | translate }} {{visibleValue().length}}
			</span>
		}

		@for (item of collection(); track item.value) {
			<ins-option
				class="option-size--small"
				[value]="item">
				{{ item.label }}
			</ins-option>
		}
		<ins-option slot="footer" class="option-size--small select-item select-list__footer">
			{{ 'ui.filter-chips.restore-default' | translate }}
		</ins-option>
	</ins-select>
</ins-form-field>
